import { PermissionType } from './application.types';

export const types = {
    LOAD_APPLICATION: 'LOAD_APPLICATION',
    LOAD_APPLICATION_DONE: 'LOAD_APPLICATION_DONE',
    WINDOW_FOCUS: 'WINDOW_FOCUS',
    WINDOW_BLUR: 'WINDOW_BLUR',
    SET_CAMERA_PERMISSION: 'SET_CAMERA_PERMISSION',
};

const loadApplication = () => ({ type: types.LOAD_APPLICATION });
const loadApplicationDone = (applicationInfo: any) => ({
    type: types.LOAD_APPLICATION_DONE,
    payload: applicationInfo,
});

const windowFocus = () => ({
    type: types.WINDOW_FOCUS,
});
const windowBlur = () => ({
    type: types.WINDOW_BLUR,
});

const setCameraPermission = (permission: PermissionType | undefined) => ({
    type: types.SET_CAMERA_PERMISSION,
    payload: permission,
});

export default {
    loadApplication,
    loadApplicationDone,
    windowFocus,
    windowBlur,
    setCameraPermission,
} as const;
